<template>
  <div id="app" v-cloak>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  created(){
    // window.addEventListener('resize',()=>{
    //   this.resize() 
    // },true)
  },
  mounted(){
    // this.resize()
  },
  methods:{
    // resize () {
    //       // 系统整体缩放
    //       let cliWidth = document.documentElement.clientWidth || document.body.clientWidth
    //       let cliHeight = document.documentElement.clientHeight || document.body.clientHeight
    //       let contW = 1920
    //       let contH = 1080
    //       let w = cliWidth / contW
    //       let h = cliHeight / contH
    //       let appDom = document.querySelector('#app')
    //       appDom.style.transform = 'scale(' + w + ',' + h + ')'
    //       appDom.style.transformOrigin = 'top left'
    //       appDom.style.width = contW + 'px'
    //       appDom.style.height = contH + 'px'
    // },
  }
}
</script>

<style>
body,html,#app{
  margin: 0;
  padding: 0;
  min-width: 1560px;
  height: 100%;
}
[v-cloak]{
  display: none;
}
</style>
